import { render, staticRenderFns } from "./InvoiceSendingPage.vue?vue&type=template&id=e936e2f0&"
import script from "./InvoiceSendingPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceSendingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports